import React from 'react'
import LogoImg from '../images/logo.jpg'
import KoreaFlagImg from '../images/korea-flag.png'

const Header = ({ activePath }) => {
  return (
    <div className="container">
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container-fluid px-0">
          <a className="navbar-brand logo-title" href="/">
            <img src={LogoImg} className="logo" alt="DYEC logo" width="45" />
            <span className="header-title-desktop">DONG-YANG ELECTRONICS CO., LTD.</span>
            <span className="header-title-mobile">DONG-YANG ELECTRONICS</span>
            <img src={KoreaFlagImg} className="flag" alt="Flag of South Korea" title="Flag of South Korea" width="30" />
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarToggler">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className={`nav-link ${activePath === '/' ? 'active' : ''}`} aria-current="page" href="/">Home</a>
              </li>
              <li className="nav-item">
                <a className={`nav-link ${activePath === '/products' ? 'active' : ''}`} href="/products">Products</a>
              </li>
              <li className="nav-item">
                <a className={`nav-link ${activePath === '/company' ? 'active' : ''}`} href="/company">Company</a>
              </li>
              <li className="nav-item">
                <a className={`nav-link ${activePath === '/contact' ? 'active' : ''}`} href="/contact">Contact</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Header
